/**
 * DownloadData slot component.
 *
 * @deprecated Use chart-specific DownloadCSV slot instead (e.g. \<CategoricalBarChart.DownloadCSV /\>).
 */
export const DownloadData = () => null;

// eslint-disable-next-line @typescript-eslint/no-deprecated
DownloadData['displayName'] = 'ChartInteractions.DownloadData';
